<template>
  <div>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
    ></div>
  </div>
</template>

<script>
  import VueGallery from 'vue-gallery';
  
  export default {
    data: function () {
      return {
        images: [
          './assets/DSC03514.jpg',
          './assets/DSC03547.jpg',
          './assets/DSC03805.jpg',
          './assets/DSC03816.jpg',
          './assets/DSC03818.jpg',
          './assets/DSC03829.jpg',
          './assets/DSC03832.jpg',
          './assets/DSC03844.jpg',
          './assets/DSC03846.jpg',
          './assets/DSC03848.jpg',
          './assets/DSC04126.jpg',
          './assets/DSC04136.jpg',
          './assets/DSC04146.jpg',
          './assets/DSC04151.jpg',
          './assets/DSC04159.jpg',
          './assets/DSC04164.jpg',
          './assets/DSC04170.jpg',
          './assets/DSC04171.jpg',
          './assets/DSC04185.jpg',
          './assets/DSC04226.jpg',
          './assets/DSC04272.jpg',
          './assets/DSC04273.jpg',
          './assets/DSC04279.jpg',
          './assets/DSC04289.jpg',
          './assets/DSC04290.jpg',
          './assets/DSC04298.jpg',
          './assets/DSC04313.jpg',
          './assets/DSC04327.jpg',
          './assets/DSC04334.jpg',
          './assets/DSC04339.jpg',
        ],
        index: null
      };
    },

    components: {
      'gallery': VueGallery
    },
  }
</script> 

<style scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>